"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AuthRequest = void 0;

var _tokenManager = _interopRequireDefault(require("../token-manager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const successCodes = [200, 201, 202, 204, 206];

const AuthRequest = geckoAuthUrl => {
  const handler = {
    getBaseUrl: function getBaseUrl() {
      return geckoAuthUrl;
    },
    getAuthRedirectUrl: function getAuthRedirectUrl() {
      return `${geckoAuthUrl}/logout`;
    },
    prepareUrl: function prepareUrl(endpoint = '') {
      return handler.getBaseUrl() + endpoint;
    },
    sanatizeParams: function sanatizeParams() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // Check params dont use undefined

      for (var prop in params) {
        if (params[prop] === undefined) params[prop] = null;
      }

      return params;
    },
    post: function post(endpoint) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var headers = {};
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json';

      if (options.Authorization) {
        headers['Authorization'] = options.Authorization;
      }

      if (!options.dont_refresh_tokens) {
        handler.refreshTokens();
      }

      return new Promise(function (resolve, reject) {
        fetch(handler.prepareUrl(endpoint), {
          method: 'POST',
          body: JSON.stringify(handler.sanatizeParams(params)),
          headers: headers
        }).then(function (response) {
          var resolveFunc = successCodes.includes(response.status) ? resolve : reject;

          if (response.status === 204) {
            resolveFunc(true);
          } else if (!options.raw) {
            response.json().then(resolveFunc).catch(reject);
          } else {
            resolveFunc(response);
          }
        }).catch(reject);
      });
    },
    get: function get(endpoint, params) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var headers = {};

      if (options.Authorization) {
        headers['Authorization'] = options.Authorization;
      }

      return new Promise(function (resolve, reject) {
        fetch(handler.prepareUrl(endpoint), {
          method: 'GET',
          headers: headers
        }).then(function (response) {
          var resolveFunc = successCodes.includes(response.status) ? resolve : reject;

          if (response.status === 204) {
            resolveFunc(true);
          } else if (!options.raw) {
            response.json().then(resolveFunc).catch(reject);
          } else {
            resolveFunc(response);
          }
        }).catch(reject);
      });
    },
    refreshTokens: function refreshTokens() {
      if (_tokenManager.default) {
        return _tokenManager.default.refreshToken();
      } else {
        throw new Error('TokenManager not defined on window');
      }
    }
  };
  return handler;
};

exports.AuthRequest = AuthRequest;
var _default = AuthRequest;
exports.default = _default;